import {
  FETCH_POLICIES_CONFIG_ASYNC,
  FETCH_POLICIES_SCHEMA_ASYNC,
  SAVE_POLICIES_CONFIG_ASYNC,
} from './constants'

export const fetchPoliciesSchema = () => ({ type: FETCH_POLICIES_SCHEMA_ASYNC.INITIATE })
export const fetchPoliciesSchemaSuccess = (data) => ({
  type: FETCH_POLICIES_SCHEMA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchPoliciesSchemaError = (error) => ({
  type: FETCH_POLICIES_SCHEMA_ASYNC.ERROR,
  error,
})

export const savePoliciesConfig = (payload) => ({
  type: SAVE_POLICIES_CONFIG_ASYNC.INITIATE,
  payload,
})
export const savePoliciesConfigSuccess = (data) => ({
  type: SAVE_POLICIES_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const savePoliciesConfigError = (error) => ({
  type: SAVE_POLICIES_CONFIG_ASYNC.ERROR,
  error,
})

export const fetchPoliciesConfig = () => ({ type: FETCH_POLICIES_CONFIG_ASYNC.INITIATE })
export const fetchPoliciesConfigSuccess = () => ({
  type: FETCH_POLICIES_CONFIG_ASYNC.SUCCESS,
})
export const fetchPoliciesConfigError = (error) => ({
  type: FETCH_POLICIES_CONFIG_ASYNC.ERROR,
  error,
})

export default {
  fetchPoliciesSchema,
  savePoliciesConfig,
  fetchPoliciesConfig,
}
